import React from 'react';
import Spline from '@splinetool/react-spline';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { whatsappNumber, whatsappMessage } from '../data/mock';

const Hero = () => {
  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content-wrapper">
        {/* Left Content */}
        <div className="hero-left">
          <div className="hero-text-content">
            <h1 className="hero-title">
              Creamos páginas web modernas que hacen{' '}
              <span className="text-brand">crecer tu negocio</span>
            </h1>
            <p className="hero-subtitle">
              En LTechSolutions diseñamos sitios rápidos, profesionales y optimizados para que tu marca tenga presencia online y puedas atraer más clientes. Nos encargamos de todo el proceso: diseño, desarrollo, optimización y soporte.
            </p>
            <div className="hero-buttons">
              <button onClick={scrollToServices} className="btn-primary">
                Ver nuestros servicios
                <ArrowRight size={20} />
              </button>
              <button onClick={handleWhatsAppClick} className="btn-secondary">
                <MessageCircle size={20} />
                Contactar ahora
              </button>
            </div>
          </div>
        </div>

        {/* Right Content - Spline 3D */}
        <div className="hero-right">
          <div className="spline-container">
            <Spline 
              scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
            />
          </div>
        </div>
      </div>

      {/* Background Effects */}
      <div className="hero-bg-glow"></div>
      <div className="circuit-pattern"></div>
    </section>
  );
};

export default Hero;
